import React from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useSearchParams,
} from "react-router-dom";
import InstitutionFeed from "./components/InstitutionFeed";
import SnippetView from "./components/SnippetView";
import { InstitutionProvider } from "./contexts/InstitutionContext";
import "./App.css";

function InstitutionRoute() {
  const [searchParams] = useSearchParams();
  const hasSnippetParam = searchParams.has("snippet");

  if (hasSnippetParam) {
    return <SnippetView />;
  }

  return <InstitutionFeed />;
}

function InstitutionWrapper() {
  return (
    <InstitutionProvider>
      <InstitutionRoute />
    </InstitutionProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:institutionId" element={<InstitutionWrapper />} />
        <Route
          path="/"
          element={
            <div className="enter-screen">
              <div className="enter-content">
                <h1>🎥 Coaching Feed</h1>
                <p>Please provide an institution ID in the URL</p>
              </div>
            </div>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
